/** Navy-tinted shadow family (never grey). `sm` carries the card hairline ring — cards use it instead of a border. */
export const shadows = {
  xs: "0 1px 2px rgba(19,27,77,0.06)",
  sm: "0 0 0 1px #E8E5DC, 0 1px 2px rgba(19,27,77,0.04), 0 8px 24px -12px rgba(19,27,77,0.10)",
  base: "0 0 0 1px #E8E5DC, 0 1px 2px rgba(19,27,77,0.04), 0 8px 24px -12px rgba(19,27,77,0.10)",
  md: "0 0 0 1px #E8E5DC, 0 4px 12px rgba(19,27,77,0.08), 0 1px 3px rgba(19,27,77,0.06)",
  lg: "0 0 0 1px #E8E5DC, 0 12px 32px rgba(19,27,77,0.14), 0 2px 6px rgba(19,27,77,0.06)",
  xl: "0 24px 64px rgba(11,16,53,0.28), 0 4px 12px rgba(11,16,53,0.10)",
  "2xl": "0 24px 64px rgba(11,16,53,0.28), 0 4px 12px rgba(11,16,53,0.10)",
  glowGreen: "0 8px 24px -6px rgba(107,191,89,0.45)",
  insetNav: "inset 0 1px 0 rgba(255,255,255,0.35)",
  /** Focus ring on light surfaces: opaque 4px green ring with a 1px white gap. */
  outline: "0 0 0 1px #FFFFFF, 0 0 0 4px #6BBF59",
  /** Focus ring on navy surfaces (sidebar, hero band). */
  outlineOnDark: "0 0 0 1px #131B4D, 0 0 0 4px #FFFFFF",
  outlineDanger: "0 0 0 1px #FFFFFF, 0 0 0 4px #DC2626",
};
